import { IAutomationSchedule } from '@dadohr/shared/domainTypes/automations';
import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { FS } from '@dadohr/shared/versions';
import moment from 'moment-timezone';
import { store } from '../firebase';
import {
  CollectionListener,
  createCollectionListenerStore,
  useCollectionListener
} from '../firecache/collectionListener';
import { MomentRange, fromMoment } from '../time';

const collection = () => store().collection(FS.automationSchedules);
export const toAutomationScheduleDoc = generateToDocFn<IAutomationSchedule>();

const DELIMITER = '@@@';
const toCacheKey = ({
  id,
  orgId,
  range
}: {
  id: string;
  orgId: string;
  range: MomentRange;
}) => {
  return [id, orgId, `${range.start.valueOf()}`, `${range.end.valueOf()}`].join(
    DELIMITER
  );
};
const fromCacheKey = (key: string) => {
  const [id, orgId, start, end] = key.split(DELIMITER);
  return {
    id,
    orgId,
    range: {
      start: moment(parseInt(start, 10)),
      end: moment(parseInt(end, 10))
    }
  };
};

const getSchedulesStore = createCollectionListenerStore((key) => {
  const { id: tplId, orgId, range } = fromCacheKey(key);
  return new CollectionListener(
    collection()
      .where('orgId', '==', orgId)
      .where('templateId', '==', tplId)
      .where('at', '>=', fromMoment(range.start))
      .where('at', '<', fromMoment(range.end)),
    toAutomationScheduleDoc
  );
});
export const useAutomationSchedulesByExperienceTemplateId = (
  orgId: string,
  tplId: string,
  range: MomentRange
) => {
  return useCollectionListener(
    getSchedulesStore(toCacheKey({ id: tplId, orgId, range }))
  );
};
